const Dn = [
  { code: "AF", label: "Afghanistan" },
  { code: "AL", label: "Albania" },
  { code: "DZ", label: "Algeria" },
  { code: "AS", label: "American Samoa" },
  { code: "AD", label: "Andorra" },
  { code: "AO", label: "Angola" },
  { code: "AI", label: "Anguilla" },
  { code: "AQ", label: "Antarctica" },
  { code: "AG", label: "Antigua and Barbuda" },
  { code: "AR", label: "Argentina" },
  { code: "AM", label: "Armenia" },
  { code: "AW", label: "Aruba" },
  { code: "AU", label: "Australia" },
  { code: "AT", label: "Austria" },
  { code: "AZ", label: "Azerbaijan" },
  { code: "BS", label: "Bahamas" },
  { code: "BH", label: "Bahrain" },
  { code: "BD", label: "Bangladesh" },
  { code: "BB", label: "Barbados" },
  { code: "BY", label: "Belarus" },
  { code: "BE", label: "Belgium" },
  { code: "BZ", label: "Belize" },
  { code: "BJ", label: "Benin" },
  { code: "BM", label: "Bermuda" },
  { code: "BT", label: "Bhutan" },
  { code: "BO", label: "Bolivia, Plurinational State of" },
  { code: "BQ", label: "Bonaire, Sint Eustatius and Saba" },
  { code: "BA", label: "Bosnia and Herzegovina" },
  { code: "BW", label: "Botswana" },
  { code: "BV", label: "Bouvet Island" },
  { code: "BR", label: "Brazil" },
  { code: "IO", label: "British Indian Ocean Territory" },
  { code: "BN", label: "Brunei Darussalam" },
  { code: "BG", label: "Bulgaria" },
  { code: "BF", label: "Burkina Faso" },
  { code: "BI", label: "Burundi" },
  { code: "KH", label: "Cambodia" },
  { code: "CM", label: "Cameroon" },
  { code: "CA", label: "Canada" },
  { code: "CV", label: "Cape Verde" },
  { code: "KY", label: "Cayman Islands" },
  { code: "CF", label: "Central African Republic" },
  { code: "TD", label: "Chad" },
  { code: "CL", label: "Chile" },
  { code: "CN", label: "China" },
  { code: "CX", label: "Christmas Island" },
  { code: "CC", label: "Cocos (Keeling) Islands" },
  { code: "CO", label: "Colombia" },
  { code: "KM", label: "Comoros" },
  { code: "CG", label: "Congo" },
  { code: "CD", label: "Congo, the Democratic Republic of the" },
  { code: "CK", label: "Cook Islands" },
  { code: "CR", label: "Costa Rica" },
  { code: "HR", label: "Croatia" },
  { code: "CU", label: "Cuba" },
  { code: "CW", label: "Curaçao" },
  { code: "CY", label: "Cyprus" },
  { code: "CZ", label: "Czech Republic" },
  { code: "CI", label: "Côte d'Ivoire" },
  { code: "DK", label: "Denmark" },
  { code: "DJ", label: "Djibouti" },
  { code: "DM", label: "Dominica" },
  { code: "DO", label: "Dominican Republic" },
  { code: "EC", label: "Ecuador" },
  { code: "EG", label: "Egypt" },
  { code: "SV", label: "El Salvador" },
  { code: "GQ", label: "Equatorial Guinea" },
  { code: "ER", label: "Eritrea" },
  { code: "EE", label: "Estonia" },
  { code: "ET", label: "Ethiopia" },
  { code: "FK", label: "Falkland Islands (Malvinas)" },
  { code: "FO", label: "Faroe Islands" },
  { code: "FJ", label: "Fiji" },
  { code: "FI", label: "Finland" },
  { code: "FR", label: "France" },
  { code: "GF", label: "French Guiana" },
  { code: "PF", label: "French Polynesia" },
  { code: "TF", label: "French Southern Territories" },
  { code: "GA", label: "Gabon" },
  { code: "GM", label: "Gambia" },
  { code: "GE", label: "Georgia" },
  { code: "DE", label: "Germany" },
  { code: "GH", label: "Ghana" },
  { code: "GI", label: "Gibraltar" },
  { code: "GR", label: "Greece" },
  { code: "GL", label: "Greenland" },
  { code: "GD", label: "Grenada" },
  { code: "GP", label: "Guadeloupe" },
  { code: "GU", label: "Guam" },
  { code: "GT", label: "Guatemala" },
  { code: "GG", label: "Guernsey" },
  { code: "GN", label: "Guinea" },
  { code: "GW", label: "Guinea-Bissau" },
  { code: "GY", label: "Guyana" },
  { code: "HT", label: "Haiti" },
  { code: "VA", label: "Holy See (Vatican City State)" },
  { code: "HN", label: "Honduras" },
  { code: "HK", label: "Hong Kong" },
  { code: "HU", label: "Hungary" },
  { code: "IS", label: "Iceland" },
  { code: "IN", label: "India" },
  { code: "ID", label: "Indonesia" },
  { code: "IR", label: "Iran, Islamic Republic of" },
  { code: "IQ", label: "Iraq" },
  { code: "IE", label: "Ireland" },
  { code: "IM", label: "Isle of Man" },
  { code: "IL", label: "Israel" },
  { code: "IT", label: "Italy" },
  { code: "JM", label: "Jamaica" },
  { code: "JP", label: "Japan" },
  { code: "JE", label: "Jersey" },
  { code: "JO", label: "Jordan" },
  { code: "KZ", label: "Kazakhstan" },
  { code: "KE", label: "Kenya" },
  { code: "KI", label: "Kiribati" },
  { code: "KP", label: "Korea, Democratic People's Republic of" },
  { code: "KR", label: "Korea, Republic of" },
  { code: "KW", label: "Kuwait" },
  { code: "KG", label: "Kyrgyzstan" },
  { code: "LA", label: "Lao People's Democratic Republic" },
  { code: "LV", label: "Latvia" },
  { code: "LB", label: "Lebanon" },
  { code: "LS", label: "Lesotho" },
  { code: "LR", label: "Liberia" },
  { code: "LY", label: "Libya" },
  { code: "LI", label: "Liechtenstein" },
  { code: "LT", label: "Lithuania" },
  { code: "LU", label: "Luxembourg" },
  { code: "MO", label: "Macao" },
  { code: "MK", label: "Macedonia, the Former Yugoslav Republic of" },
  { code: "MG", label: "Madagascar" },
  { code: "MW", label: "Malawi" },
  { code: "MY", label: "Malaysia" },
  { code: "MV", label: "Maldives" },
  { code: "ML", label: "Mali" },
  { code: "MT", label: "Malta" },
  { code: "MH", label: "Marshall Islands" },
  { code: "MQ", label: "Martinique" },
  { code: "MR", label: "Mauritania" },
  { code: "MU", label: "Mauritius" },
  { code: "YT", label: "Mayotte" },
  { code: "MX", label: "Mexico" },
  { code: "FM", label: "Micronesia, Federated States of" },
  { code: "MD", label: "Moldova, Republic of" },
  { code: "MC", label: "Monaco" },
  { code: "MN", label: "Mongolia" },
  { code: "ME", label: "Montenegro" },
  { code: "MS", label: "Montserrat" },
  { code: "MA", label: "Morocco" },
  { code: "MZ", label: "Mozambique" },
  { code: "MM", label: "Myanmar" },
  { code: "NA", label: "Namibia" },
  { code: "NR", label: "Nauru" },
  { code: "NP", label: "Nepal" },
  { code: "NL", label: "Netherlands" },
  { code: "NC", label: "New Caledonia" },
  { code: "NZ", label: "New Zealand" },
  { code: "NI", label: "Nicaragua" },
  { code: "NE", label: "Niger" },
  { code: "NG", label: "Nigeria" },
  { code: "NU", label: "Niue" },
  { code: "NF", label: "Norfolk Island" },
  { code: "MP", label: "Northern Mariana Islands" },
  { code: "NO", label: "Norway" },
  { code: "OM", label: "Oman" },
  { code: "PK", label: "Pakistan" },
  { code: "PW", label: "Palau" },
  { code: "PS", label: "Palestine, State of" },
  { code: "PA", label: "Panama" },
  { code: "PG", label: "Papua New Guinea" },
  { code: "PY", label: "Paraguay" },
  { code: "PE", label: "Peru" },
  { code: "PH", label: "Philippines" },
  { code: "PN", label: "Pitcairn" },
  { code: "PL", label: "Poland" },
  { code: "PT", label: "Portugal" },
  { code: "PR", label: "Puerto Rico" },
  { code: "QA", label: "Qatar" },
  { code: "RO", label: "Romania" },
  { code: "RU", label: "Russian Federation" },
  { code: "RW", label: "Rwanda" },
  { code: "RE", label: "Réunion" },
  { code: "BL", label: "Saint Barthélemy" },
  { code: "SH", label: "Saint Helena, Ascension and Tristan da Cunha" },
  { code: "KN", label: "Saint Kitts and Nevis" },
  { code: "LC", label: "Saint Lucia" },
  { code: "MF", label: "Saint Martin (French part)" },
  { code: "PM", label: "Saint Pierre and Miquelon" },
  { code: "VC", label: "Saint Vincent and the Grenadines" },
  { code: "WS", label: "Samoa" },
  { code: "SM", label: "San Marino" },
  { code: "ST", label: "Sao Tome and Principe" },
  { code: "SA", label: "Saudi Arabia" },
  { code: "SN", label: "Senegal" },
  { code: "RS", label: "Serbia" },
  { code: "SC", label: "Seychelles" },
  { code: "SL", label: "Sierra Leone" },
  { code: "SG", label: "Singapore" },
  { code: "SX", label: "Sint Maarten (Dutch part)" },
  { code: "SK", label: "Slovakia" },
  { code: "SI", label: "Slovenia" },
  { code: "SB", label: "Solomon Islands" },
  { code: "SO", label: "Somalia" },
  { code: "ZA", label: "South Africa" },
  { code: "GS", label: "South Georgia and the South Sandwich Islands" },
  { code: "SS", label: "South Sudan" },
  { code: "ES", label: "Spain" },
  { code: "LK", label: "Sri Lanka" },
  { code: "SD", label: "Sudan" },
  { code: "SR", label: "Suriname" },
  { code: "SJ", label: "Svalbard and Jan Mayen" },
  { code: "SZ", label: "Swaziland" },
  { code: "SE", label: "Sweden" },
  { code: "CH", label: "Switzerland" },
  { code: "SY", label: "Syrian Arab Republic" },
  { code: "TW", label: "Taiwan" },
  { code: "TJ", label: "Tajikistan" },
  { code: "TZ", label: "Tanzania, United Republic of" },
  { code: "TH", label: "Thailand" },
  { code: "TL", label: "Timor-Leste" },
  { code: "TG", label: "Togo" },
  { code: "TK", label: "Tokelau" },
  { code: "TO", label: "Tonga" },
  { code: "TT", label: "Trinidad and Tobago" },
  { code: "TN", label: "Tunisia" },
  { code: "TR", label: "Turkey" },
  { code: "TM", label: "Turkmenistan" },
  { code: "TC", label: "Turks and Caicos Islands" },
  { code: "TV", label: "Tuvalu" },
  { code: "UG", label: "Uganda" },
  { code: "UA", label: "Ukraine" },
  { code: "AE", label: "United Arab Emirates" },
  { code: "GB", label: "United Kingdom" },
  { code: "US", label: "United States" },
  { code: "UM", label: "United States Minor Outlying Islands" },
  { code: "UY", label: "Uruguay" },
  { code: "UZ", label: "Uzbekistan" },
  { code: "VU", label: "Vanuatu" },
  { code: "VE", label: "Venezuela, Bolivarian Republic of" },
  { code: "VN", label: "Viet Nam" },
  { code: "VG", label: "Virgin Islands, British" },
  { code: "VI", label: "Virgin Islands, U.S." },
  { code: "WF", label: "Wallis and Futuna" },
  { code: "EH", label: "Western Sahara" },
  { code: "YE", label: "Yemen" },
  { code: "ZM", label: "Zambia" },
  { code: "ZW", label: "Zimbabwe" },
  { code: "AX", label: "Åland Islands" }
], pn = {
  CA: [
    ["", "(Provinces/Territories)"],
    ["AB", "Alberta"],
    ["BC", "British Columbia"],
    ["NL", "Newfoundland & Labrador"],
    ["MB", "Manitoba"],
    ["NB", "New Brunswick"],
    ["NS", "Nova Scotia"],
    ["ON", "Ontario"],
    ["PE", "Prince Edward Island"],
    ["QC", "Québec"],
    ["SK", "Saskatchewan"],
    ["NT", "Northwest Territories"],
    ["NU", "Nunavut"],
    ["YT", "Yukon"]
  ],
  US: [
    ["", "(State)"],
    ["AK", "Alaska"],
    ["AL", "Alabama"],
    ["AM", "American Samoa"],
    ["AA", "Armed Forces (the) Americas"],
    ["AE", "Armed Forces Europe"],
    ["AP", "Armed Forces Pacific"],
    ["AR", "Arkansas"],
    ["AZ", "Arizona"],
    ["CA", "California"],
    ["CO", "Colorado"],
    ["CT", "Connecticut"],
    ["DC", "District of Columbia"],
    ["DE", "Delaware"],
    ["FL", "Florida"],
    ["GA", "Georgia"],
    ["GU", "Guam"],
    ["HI", "Hawaii"],
    ["IA", "Iowa"],
    ["ID", "Idaho"],
    ["IL", "Illinois"],
    ["IN", "Indiana"],
    ["KS", "Kansas"],
    ["KY", "Kentucky"],
    ["LA", "Louisiana"],
    ["MA", "Massachusetts"],
    ["MD", "Maryland"],
    ["ME", "Maine"],
    ["MI", "Michigan"],
    ["MN", "Minnesota"],
    ["MO", "Missouri"],
    ["MP", "Northern Mariana Islands"],
    ["MS", "Mississippi"],
    ["MT", "Montana"],
    /* ['NA', '_Tribal Govt.'], */
    ["NC", "North Carolina"],
    ["ND", "North Dakota"],
    ["NE", "Nebraska"],
    ["NH", "New Hampshire"],
    ["NJ", "New Jersey"],
    ["NM", "New Mexico"],
    ["NV", "Nevada"],
    ["NY", "New York"],
    ["OH", "Ohio"],
    ["OK", "Oklahoma"],
    ["OR", "Oregon"],
    ["PA", "Pennsylvania"],
    ["PR", "Puerto Rico"],
    ["RI", "Rhode Island"],
    ["SC", "South Carolina"],
    ["SD", "South Dakota"],
    ["TN", "Tennessee"],
    ["TX", "Texas"],
    ["UT", "Utah"],
    ["VA", "Virginia"],
    ["VI", "Virgin Islands"],
    ["VT", "Vermont"],
    ["WA", "Washington"],
    ["WI", "Wisconsin"],
    ["WV", "West Virginia"],
    ["WY", "Wyoming"]
  ],
  AU: [
    ["", "(States/Territories)"],
    ["ACT", "Australian Capital Territory"],
    ["NSW", "New South Wales"],
    ["NT.", "Northern Territory"],
    ["QLD", "Queensland"],
    ["SA", "South Australia"],
    ["TAS", "Tasmania"],
    ["VIC", "Victoria"],
    ["WA.", "Western Australia"]
  ]
}, me = 6048e5, De = 864e5, pe = 36e5, q = Symbol.for("constructDateFrom");
function y(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && q in e ? e[q](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function h(e, t) {
  return y(t || e, e);
}
function Ne(e, t, n) {
  const a = h(e, n?.in);
  return isNaN(t) ? y(e, NaN) : (a.setDate(a.getDate() + t), a);
}
function Te(e, t, n) {
  return y(e, +h(e) + t);
}
function Se(e, t, n) {
  return Te(e, t * pe);
}
let Oe = {};
function E() {
  return Oe;
}
function Y(e, t) {
  const n = E(), a = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = h(e, t?.in), o = r.getDay(), i = (o < a ? 7 : 0) + o - a;
  return r.setDate(r.getDate() - i), r.setHours(0, 0, 0, 0), r;
}
function x(e, t) {
  return Y(e, { ...t, weekStartsOn: 1 });
}
function he(e, t) {
  const n = h(e, t?.in), a = n.getFullYear(), r = y(n, 0);
  r.setFullYear(a + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = x(r), i = y(n, 0);
  i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0);
  const s = x(i);
  return n.getTime() >= o.getTime() ? a + 1 : n.getTime() >= s.getTime() ? a : a - 1;
}
function Q(e) {
  const t = h(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function V(e, ...t) {
  const n = y.bind(
    null,
    t.find((a) => typeof a == "object")
  );
  return t.map(n);
}
function W(e, t) {
  const n = h(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Ie(e, t, n) {
  const [a, r] = V(
    n?.in,
    e,
    t
  ), o = W(a), i = W(r), s = +o - Q(o), c = +i - Q(i);
  return Math.round((s - c) / De);
}
function Pe(e, t) {
  const n = he(e, t), a = y(e, 0);
  return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), x(a);
}
function Ce(e, t, n) {
  const [a, r] = V(
    n?.in,
    e,
    t
  );
  return +W(a) == +W(r);
}
function Ye(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ee(e) {
  return !(!Ye(e) && typeof e != "number" || isNaN(+h(e)));
}
function ve(e, t) {
  const n = h(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const ke = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, xe = (e, t, n) => {
  let a;
  const r = ke[e];
  return typeof r == "string" ? a = r : t === 1 ? a = r.one : a = r.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function H(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const We = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Fe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, He = {
  date: H({
    formats: We,
    defaultWidth: "full"
  }),
  time: H({
    formats: Ae,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Fe,
    defaultWidth: "full"
  })
}, Le = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ge = (e, t, n, a) => Le[e];
function I(e) {
  return (t, n) => {
    const a = n?.context ? String(n.context) : "standalone";
    let r;
    if (a === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : i;
      r = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      r = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[o];
  };
}
const Re = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ue = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Be = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ze = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, _e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ve = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, $e = (e, t) => {
  const n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Xe = {
  ordinalNumber: $e,
  era: I({
    values: Re,
    defaultWidth: "wide"
  }),
  quarter: I({
    values: Ue,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: I({
    values: Be,
    defaultWidth: "wide"
  }),
  day: I({
    values: ze,
    defaultWidth: "wide"
  }),
  dayPeriod: I({
    values: _e,
    defaultWidth: "wide",
    formattingValues: Ve,
    defaultFormattingWidth: "wide"
  })
};
function P(e) {
  return (t, n = {}) => {
    const a = n.width, r = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], o = t.match(r);
    if (!o)
      return null;
    const i = o[0], s = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Ze(s, (m) => m.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      Ke(s, (m) => m.test(i))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(l)
    ) : l;
    const d = t.slice(i.length);
    return { value: l, rest: d };
  };
}
function Ke(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Ze(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function qe(e) {
  return (t, n = {}) => {
    const a = t.match(e.matchPattern);
    if (!a) return null;
    const r = a[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(r.length);
    return { value: i, rest: s };
  };
}
const Qe = /^(\d+)(th|st|nd|rd)?/i, je = /\d+/i, Je = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, et = {
  any: [/^b/i, /^(a|c)/i]
}, tt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, nt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, at = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, rt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ot = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, it = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, st = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ct = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, lt = {
  ordinalNumber: qe({
    matchPattern: Qe,
    parsePattern: je,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: P({
    matchPatterns: Je,
    defaultMatchWidth: "wide",
    parsePatterns: et,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: tt,
    defaultMatchWidth: "wide",
    parsePatterns: nt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: P({
    matchPatterns: at,
    defaultMatchWidth: "wide",
    parsePatterns: rt,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: ot,
    defaultMatchWidth: "wide",
    parsePatterns: it,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: st,
    defaultMatchWidth: "any",
    parsePatterns: ct,
    defaultParseWidth: "any"
  })
}, ut = {
  code: "en-US",
  formatDistance: xe,
  formatLong: He,
  formatRelative: Ge,
  localize: Xe,
  match: lt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function dt(e, t) {
  const n = h(e, t?.in);
  return Ie(n, ve(n)) + 1;
}
function ft(e, t) {
  const n = h(e, t?.in), a = +x(n) - +Pe(n);
  return Math.round(a / me) + 1;
}
function be(e, t) {
  const n = h(e, t?.in), a = n.getFullYear(), r = E(), o = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = y(t?.in || e, 0);
  i.setFullYear(a + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = Y(i, t), c = y(t?.in || e, 0);
  c.setFullYear(a, 0, o), c.setHours(0, 0, 0, 0);
  const l = Y(c, t);
  return +n >= +s ? a + 1 : +n >= +l ? a : a - 1;
}
function mt(e, t) {
  const n = E(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = be(e, t), o = y(t?.in || e, 0);
  return o.setFullYear(r, 0, a), o.setHours(0, 0, 0, 0), Y(o, t);
}
function ht(e, t) {
  const n = h(e, t?.in), a = +Y(n, t) - +mt(n, t);
  return Math.round(a / me) + 1;
}
function u(e, t) {
  const n = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(t, "0");
  return n + a;
}
const M = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
    return u(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : u(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return u(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return u(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return u(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return u(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return u(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, a = e.getMilliseconds(), r = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return u(r, t.length);
  }
}, N = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, j = {
  // Era
  G: function(e, t, n) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const a = e.getFullYear(), r = a > 0 ? a : 1 - a;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return M.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    const r = be(e, a), o = r > 0 ? r : 1 - r;
    if (t === "YY") {
      const i = o % 100;
      return u(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : u(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = he(e);
    return u(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return u(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return u(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return u(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return M.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return u(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    const r = ht(e, a);
    return t === "wo" ? n.ordinalNumber(r, { unit: "week" }) : u(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const a = ft(e);
    return t === "Io" ? n.ordinalNumber(a, { unit: "week" }) : u(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : M.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const a = dt(e);
    return t === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : u(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const a = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    const r = e.getDay(), o = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return u(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    const r = e.getDay(), o = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return u(o, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const a = e.getDay(), r = a === 0 ? 7 : a;
    switch (t) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return u(r, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const a = e.getHours();
    let r;
    switch (a === 12 ? r = N.noon : a === 0 ? r = N.midnight : r = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const a = e.getHours();
    let r;
    switch (a >= 17 ? r = N.evening : a >= 12 ? r = N.afternoon : a >= 4 ? r = N.morning : r = N.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return M.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : M.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const a = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : u(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let a = e.getHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : u(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : M.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : M.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return M.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return ee(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return D(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return D(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return ee(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return D(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return D(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + J(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + D(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + J(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + D(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const a = Math.trunc(+e / 1e3);
    return u(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return u(+e, t.length);
  }
};
function J(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = Math.trunc(a / 60), o = a % 60;
  return o === 0 ? n + String(r) : n + String(r) + t + u(o, 2);
}
function ee(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + u(Math.abs(e) / 60, 2) : D(e, t);
}
function D(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = u(Math.trunc(a / 60), 2), o = u(a % 60, 2);
  return n + r + t + o;
}
const te = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, ge = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, bt = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], a = n[1], r = n[2];
  if (!r)
    return te(e, t);
  let o;
  switch (a) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", te(a, t)).replace("{{time}}", ge(r, t));
}, gt = {
  p: ge,
  P: bt
}, wt = /^D+$/, yt = /^Y+$/, Mt = ["D", "DD", "YY", "YYYY"];
function Dt(e) {
  return wt.test(e);
}
function pt(e) {
  return yt.test(e);
}
function Nt(e, t, n) {
  const a = Tt(e, t, n);
  if (console.warn(a), Mt.includes(e)) throw new RangeError(a);
}
function Tt(e, t, n) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const St = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ot = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, It = /^'([^]*?)'?$/, Pt = /''/g, Ct = /[a-zA-Z]/;
function Yt(e, t, n) {
  const a = E(), r = n?.locale ?? a.locale ?? ut, o = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, s = h(e, n?.in);
  if (!Ee(s))
    throw new RangeError("Invalid time value");
  let c = t.match(Ot).map((d) => {
    const m = d[0];
    if (m === "p" || m === "P") {
      const O = gt[m];
      return O(d, r.formatLong);
    }
    return d;
  }).join("").match(St).map((d) => {
    if (d === "''")
      return { isToken: !1, value: "'" };
    const m = d[0];
    if (m === "'")
      return { isToken: !1, value: Et(d) };
    if (j[m])
      return { isToken: !0, value: d };
    if (m.match(Ct))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + m + "`"
      );
    return { isToken: !1, value: d };
  });
  r.localize.preprocessor && (c = r.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: r
  };
  return c.map((d) => {
    if (!d.isToken) return d.value;
    const m = d.value;
    (!n?.useAdditionalWeekYearTokens && pt(m) || !n?.useAdditionalDayOfYearTokens && Dt(m)) && Nt(m, t, String(e));
    const O = j[m[0]];
    return O(s, m, r.localize, l);
  }).join("");
}
function Et(e) {
  const t = e.match(It);
  return t ? t[1].replace(Pt, "'") : e;
}
function vt() {
  return Object.assign({}, E());
}
function v(e, t) {
  return +h(e) > +h(t);
}
function k(e, t) {
  return +h(e) < +h(t);
}
function kt(e, t, n) {
  const [a, r] = V(
    n?.in,
    e,
    t
  );
  return a.getFullYear() === r.getFullYear() && a.getMonth() === r.getMonth();
}
function xt(e, t, n) {
  const a = +h(e, n?.in), [r, o] = [
    +h(t.start, n?.in),
    +h(t.end, n?.in)
  ].sort((i, s) => i - s);
  return a >= r && a <= o;
}
function Wt(e, t, n) {
  return Se(e, -1);
}
function ne(e, t, n) {
  const a = vt(), r = Ht(e, n.timeZone, n.locale ?? a.locale);
  return "formatToParts" in r ? At(r, t) : Ft(r, t);
}
function At(e, t) {
  const n = e.formatToParts(t);
  for (let a = n.length - 1; a >= 0; --a)
    if (n[a].type === "timeZoneName")
      return n[a].value;
}
function Ft(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), a = / [\w-+ ]+$/.exec(n);
  return a ? a[0].substr(1) : "";
}
function Ht(e, t, n) {
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function Lt(e, t) {
  const n = zt(t);
  return "formatToParts" in n ? Rt(n, e) : Ut(n, e);
}
const Gt = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Rt(e, t) {
  try {
    const n = e.formatToParts(t), a = [];
    for (let r = 0; r < n.length; r++) {
      const o = Gt[n[r].type];
      o !== void 0 && (a[o] = parseInt(n[r].value, 10));
    }
    return a;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function Ut(e, t) {
  const n = e.format(t), a = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(a[3], 10),
    parseInt(a[1], 10),
    parseInt(a[2], 10),
    parseInt(a[4], 10),
    parseInt(a[5], 10),
    parseInt(a[6], 10)
  ];
}
const L = {}, ae = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Bt = ae === "06/25/2014, 00:00:00" || ae === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function zt(e) {
  return L[e] || (L[e] = Bt ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), L[e];
}
function we(e, t, n, a, r, o, i) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, n), s.setUTCHours(a, r, o, i), s;
}
const re = 36e5, _t = 6e4, G = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $(e, t, n) {
  if (!e)
    return 0;
  let a = G.timezoneZ.exec(e);
  if (a)
    return 0;
  let r, o;
  if (a = G.timezoneHH.exec(e), a)
    return r = parseInt(a[1], 10), oe(r) ? -(r * re) : NaN;
  if (a = G.timezoneHHMM.exec(e), a) {
    r = parseInt(a[2], 10);
    const i = parseInt(a[3], 10);
    return oe(r, i) ? (o = Math.abs(r) * re + i * _t, a[1] === "+" ? -o : o) : NaN;
  }
  if (Xt(e)) {
    t = new Date(t || Date.now());
    const i = n ? t : Vt(t), s = z(i, e);
    return -(n ? s : $t(t, s, e));
  }
  return NaN;
}
function Vt(e) {
  return we(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function z(e, t) {
  const n = Lt(e, t), a = we(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let r = e.getTime();
  const o = r % 1e3;
  return r -= o >= 0 ? o : 1e3 + o, a - r;
}
function $t(e, t, n) {
  let r = e.getTime() - t;
  const o = z(new Date(r), n);
  if (t === o)
    return t;
  r -= o - t;
  const i = z(new Date(r), n);
  return o === i ? o : Math.max(o, i);
}
function oe(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const ie = {};
function Xt(e) {
  if (ie[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), ie[e] = !0, !0;
  } catch {
    return !1;
  }
}
const Kt = 60 * 1e3, Zt = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const a = R(n.timeZone, e);
    if (a === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return se(a);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return T(a);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimeter
      default:
        return T(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const a = R(n.timeZone, e);
    switch (t) {
      // Hours and optional minutes
      case "x":
        return se(a);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return T(a);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimeter
      default:
        return T(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const a = R(n.timeZone, e);
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + qt(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + T(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return ne("short", e, n);
      // Long
      case "zzzz":
      default:
        return ne("long", e, n);
    }
  }
};
function R(e, t) {
  const n = e ? $(e, t, !0) / Kt : t?.getTimezoneOffset() ?? 0;
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + e);
  return n;
}
function A(e, t) {
  const n = e < 0 ? "-" : "";
  let a = Math.abs(e).toString();
  for (; a.length < t; )
    a = "0" + a;
  return n + a;
}
function T(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = A(Math.floor(a / 60), 2), o = A(Math.floor(a % 60), 2);
  return n + r + t + o;
}
function se(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + A(Math.abs(e) / 60, 2) : T(e, t);
}
function qt(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = Math.floor(a / 60), o = a % 60;
  return o === 0 ? n + String(r) : n + String(r) + t + A(o, 2);
}
function ce(e) {
  const t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), +e - +t;
}
const Qt = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, U = 36e5, le = 6e4, jt = 2, b = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Qt
};
function ye(e, t = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = t.additionalDigits == null ? jt : Number(t.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const a = Jt(e), { year: r, restDateString: o } = en(a.date, n), i = tn(o, r);
  if (i === null || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const s = i.getTime();
    let c = 0, l;
    if (a.time && (c = nn(a.time), c === null || isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || t.timeZone) {
      if (l = $(a.timeZone || t.timeZone, new Date(s + c)), isNaN(l))
        return /* @__PURE__ */ new Date(NaN);
    } else
      l = ce(new Date(s + c)), l = ce(new Date(s + c + l));
    return new Date(s + c + l);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Jt(e) {
  const t = {};
  let n = b.dateTimePattern.exec(e), a;
  if (n ? (t.date = n[1], a = n[3]) : (n = b.datePattern.exec(e), n ? (t.date = n[1], a = n[2]) : (t.date = null, a = e)), a) {
    const r = b.timeZone.exec(a);
    r ? (t.time = a.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = a;
  }
  return t;
}
function en(e, t) {
  if (e) {
    const n = b.YYY[t], a = b.YYYYY[t];
    let r = b.YYYY.exec(e) || a.exec(e);
    if (r) {
      const o = r[1];
      return {
        year: parseInt(o, 10),
        restDateString: e.slice(o.length)
      };
    }
    if (r = b.YY.exec(e) || n.exec(e), r) {
      const o = r[1];
      return {
        year: parseInt(o, 10) * 100,
        restDateString: e.slice(o.length)
      };
    }
  }
  return {
    year: null
  };
}
function tn(e, t) {
  if (t === null)
    return null;
  let n, a, r;
  if (!e || !e.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  let o = b.MM.exec(e);
  if (o)
    return n = /* @__PURE__ */ new Date(0), a = parseInt(o[1], 10) - 1, de(t, a) ? (n.setUTCFullYear(t, a), n) : /* @__PURE__ */ new Date(NaN);
  if (o = b.DDD.exec(e), o) {
    n = /* @__PURE__ */ new Date(0);
    const i = parseInt(o[1], 10);
    return on(t, i) ? (n.setUTCFullYear(t, 0, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = b.MMDD.exec(e), o) {
    n = /* @__PURE__ */ new Date(0), a = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10);
    return de(t, a, i) ? (n.setUTCFullYear(t, a, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = b.Www.exec(e), o)
    return r = parseInt(o[1], 10) - 1, fe(r) ? ue(t, r) : /* @__PURE__ */ new Date(NaN);
  if (o = b.WwwD.exec(e), o) {
    r = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10) - 1;
    return fe(r, i) ? ue(t, r, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function nn(e) {
  let t, n, a = b.HH.exec(e);
  if (a)
    return t = parseFloat(a[1].replace(",", ".")), B(t) ? t % 24 * U : NaN;
  if (a = b.HHMM.exec(e), a)
    return t = parseInt(a[1], 10), n = parseFloat(a[2].replace(",", ".")), B(t, n) ? t % 24 * U + n * le : NaN;
  if (a = b.HHMMSS.exec(e), a) {
    t = parseInt(a[1], 10), n = parseInt(a[2], 10);
    const r = parseFloat(a[3].replace(",", "."));
    return B(t, n, r) ? t % 24 * U + n * le + r * 1e3 : NaN;
  }
  return null;
}
function ue(e, t, n) {
  t = t || 0, n = n || 0;
  const a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  const r = a.getUTCDay() || 7, o = t * 7 + n + 1 - r;
  return a.setUTCDate(a.getUTCDate() + o), a;
}
const an = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], rn = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Me(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function de(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const a = Me(e);
    if (a && n > rn[t] || !a && n > an[t])
      return !1;
  }
  return !0;
}
function on(e, t) {
  if (t < 1)
    return !1;
  const n = Me(e);
  return !(n && t > 366 || !n && t > 365);
}
function fe(e, t) {
  return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function B(e, t, n) {
  return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
const sn = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function _(e, t, n = {}) {
  t = String(t);
  const a = t.match(sn);
  if (a) {
    const r = ye(n.originalDate || e, n);
    t = a.reduce(function(o, i) {
      if (i[0] === "'")
        return o;
      const s = o.indexOf(i), c = o[s - 1] === "'", l = o.replace(i, "'" + Zt[i[0]](r, i, n) + "'");
      return c ? l.substring(0, s - 1) + l.substring(s + 1) : l;
    }, t);
  }
  return Yt(e, t, n);
}
function w(e, t, n) {
  e = ye(e, n);
  const a = $(t, e, !0), r = new Date(e.getTime() - a), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), o.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), o;
}
function cn(e, t, n, a) {
  return a = {
    ...a,
    timeZone: t,
    originalDate: e
  }, _(w(e, t, { timeZone: a.timeZone }), n, a);
}
var f = /* @__PURE__ */ ((e) => (e.consignment = "consignment", e.comingSoon = "coming-soon", e.openNow = "open-now", e.previewReady = "preview-ready", e.consignmentReady = "consignment-ready", e.ready = "ready", e.live = "live", e.ending = "ending", e.ended = "ended", e))(f || {}), C = /* @__PURE__ */ ((e) => (e.cancel = "CANCEL", e.complete = "COMP", e.finished = "FINISHED", e.new = "NEW", e.postponed = "POSTPONE", e.ready = "READY", e.settled = "SETTLE", e))(C || {}), S = /* @__PURE__ */ ((e) => (e.online = "ONLINE", e.private = "PRIAUC", e.live = "PUBLIC", e.exhibition = "EXHIBITION", e))(S || {}), p = /* @__PURE__ */ ((e) => (e.ended = "EN", e.inProgress = "IP", e.notStarted = "NS", e.paused = "PD", e))(p || {}), ln = /* @__PURE__ */ ((e) => (e.AM = "AM", e.A3 = "A3", e.BRK = "bruun_rasmussen", e.BUK = "bukowskis", e.BBE = "bonhams_bidding_engine", e))(ln || {}), un = /* @__PURE__ */ ((e) => (e.online = "online", e.house = "house", e))(un || {}), dn = /* @__PURE__ */ ((e) => (e.web = "web", e.ios = "ios", e.android = "android", e.aggregator = "aggregator", e.system = "system", e))(dn || {}), fn = /* @__PURE__ */ ((e) => (e.bonhams = "bonhams", e.skinner = "skinner", e.bukowskis = "bukowskis", e.bruunRasmussen = "bruun_rasmussen", e.cornette = "cornette", e.cars = "bonhams-cars", e.carsOnline = "bonhams-cars-online", e))(fn || {}), mn = /* @__PURE__ */ ((e) => (e.unitedKingdom = "UNITED_KINGDOM", e.asiaPacific = "ASIA_PACIFIC", e.asiaSouth = "ASIA_SOUTH", e.americas = "AMERICAS", e.europe = "EUROPE", e.middleEastAfrica = "MIDDLE_EAST_AFRICA", e))(mn || {}), hn = /* @__PURE__ */ ((e) => (e.withdrawn = "WD", e.withoutResults = "WR", e.unsold = "BI", e.sold = "SOLD", e.cancelled = "CS", e.noLot = "NL", e.new = "NEW", e))(hn || {}), bn = /* @__PURE__ */ ((e) => (e.brand = "brand", e.countryName = "country.name", e.countryCode = "country.code", e.departmentCode = "department.code", e.departmentName = "department.name", e.isWithoutReserve = "flags.isWithoutReserve", e.priceGBPHighEstimate = "price.GBPHighEstimate", e.priceGBPLowEstimate = "price.GBPLowEstimate", e.priceEstimateHigh = "price.estimateHigh", e.priceEstimateLow = "price.estimateLow", e.status = "status", e.groups = "groups", e))(bn || {}), gn = /* @__PURE__ */ ((e) => (e.PENDING = "PENDING", e.APPROVED = "APPROVED", e.REJECTED = "REJECTED", e))(gn || {}), wn = /* @__PURE__ */ ((e) => (e.artist = "artist", e.auction = "sale", e.department = "department", e.lot = "lot", e))(wn || {});
const yn = ({
  startDate: e,
  endDate: t,
  timeZone: n,
  timezoneAbbreviation: a,
  options: r = {
    hideYear: !1,
    hideTime: !1
  }
}) => {
  const o = w(e, n), i = w(t, n);
  let s;
  const c = (l, d) => _(l, d, {
    timeZone: n
  });
  return Ce(o, i) ? s = c(
    o,
    `d LLLL${r.hideYear ? "" : " yyyy"}`
  ) : kt(o, i) ? s = c(o, "d – ") + c(i, `d LLLL${r.hideYear ? "" : " yyyy"}`) : s = c(o, "d LLLL – ") + c(i, `d LLLL${r.hideYear ? "" : " yyyy"}`), `${s}${r.hideTime ? "" : `${_(
    o,
    `, HH:mm ${a ? `'${a}'` : "zzz"}`,
    {
      timeZone: n
    }
  )}`}`;
}, Nn = (e, t, n, a, r, o) => {
  const i = w(/* @__PURE__ */ new Date(), e), s = w(n, e), c = w(a, e), l = o === f.ended || c.getFullYear() !== i.getFullYear(), d = r === S.live && [
    f.consignment,
    f.previewReady,
    f.comingSoon,
    f.ready
  ].includes(o) && k(s, Ne(i, 1));
  return yn({
    startDate: n,
    endDate: a,
    timeZone: e,
    timezoneAbbreviation: t,
    options: {
      hideYear: !l,
      hideTime: !d
    }
  });
}, Tn = ({
  date: e,
  timezoneAbbreviation: t,
  timezone: n
}) => cn(
  e,
  n,
  `HH:mm ${t ? `'${t}'` : "zzz"}`
);
function Sn({
  policy: e,
  currentBid: t,
  amountOfOptions: n = 1 / 0,
  maxPossibleBid: a = 1 / 0,
  amountOfExtraOptions: r = 0
}) {
  const o = [], i = Object.keys(e).sort(
    (c, l) => parseInt(c) - parseInt(l)
  );
  let s = 0;
  return i.forEach((c, l) => {
    if (o.length >= n) return;
    const d = i[l + 1] !== void 0 ? parseInt(i[l + 1]) : 1 / 0, m = parseInt(c);
    if (t < d) {
      const O = t % m || 0;
      let g = Math.max(
        t - O,
        m
      );
      const F = e[c], X = F.length;
      for (let K = 1; g < d; K++) {
        const Z = K % X;
        if (Z === 0 ? g = g + F[X - 1] : g = g + F[Z - 1], g > t) {
          if (o.length >= n) break;
          if (r) {
            if (s > r) break;
            o.push(g), g >= a && (s = s + 1);
          } else {
            if (g > a) break;
            o.push(g);
          }
        }
      }
    }
  }), o;
}
const Mn = ({
  nowDate: e,
  startDate: t,
  endDate: n
}) => v(t, e) ? f.comingSoon : xt(e, {
  start: t,
  end: n
}) ? f.openNow : f.ended;
function On(e) {
  const t = w(e.endDate, e.localTimezone), n = w(e.startDate, e.localTimezone), a = w(/* @__PURE__ */ new Date(), e.localTimezone), r = e.lotCount || 0;
  if (e.type === S.exhibition)
    return Mn({ nowDate: a, startDate: n, endDate: t });
  if (e.isCharity && k(a, n))
    return f.comingSoon;
  if (e.consignmentEndDate !== null) {
    const o = w(
      e.consignmentEndDate,
      e.localTimezone
    );
    if (e.status === C.new && k(a, o))
      return r > 0 ? f.consignmentReady : f.consignment;
  }
  if (e.status === C.new)
    return r > 0 ? f.previewReady : f.comingSoon;
  if (e.status === C.ready) {
    if (e.type === S.live && e.biddingStatus === p.notStarted)
      return f.ready;
    if (e.type === S.online) {
      if (k(a, n))
        return f.previewReady;
      if (v(a, Wt(t)) && e.biddingStatus !== p.ended)
        return f.ending;
      if (v(t, a) && e.biddingStatus !== p.ended)
        return f.ready;
    }
  }
  return e.type === S.live && e.biddingStatus === p.inProgress ? f.live : v(a, t) && e.biddingStatus !== p.ended ? f.ending : e.status === C.finished || e.biddingStatus === p.ended ? f.ended : f.ready;
}
export {
  ln as AuctionBiddingEngine,
  p as AuctionBiddingStatus,
  f as AuctionProgressStatus,
  S as AuctionType,
  un as BidType,
  fn as Brand,
  dn as Channel,
  wn as FollowType,
  hn as LotStatus,
  mn as RegionType,
  gn as RegistrationStatus,
  C as SaleStatus,
  bn as TypesenseLotFacets,
  Nn as auctionDate,
  Dn as countries,
  yn as formatDateRange,
  Tn as formatTime,
  Sn as generateBidIncrements,
  On as getAuctionProgressStatus,
  pn as states
};
